import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';
import {awsConfig} from '../../shared/config';

import {setBucket, addToBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';
import {getAuthorizedClient} from '../../utils/auth/Security';


const clientsLoading = () => ({
    type: ActionTypes.CLIENTS_LOADING
});

const clientsFailed = (errmess) => ({
    type: ActionTypes.CLIENTS_FAILED,
    payload: errmess
});

const addClients = (clients) => ({
    type: ActionTypes.ADD_CLIENTS,
    payload: clients
});

const addClient = (client) => ({
    type: ActionTypes.ADD_CLIENT,
    payload: client
});

const updateClient = (client) => ({
    type: ActionTypes.UPDATE_CLIENT,
    payload: client
});

const removeClient = (clientId) => ({
  type: ActionTypes.DELETE_CLIENT,
  payload: clientId
});


export const fetchClients = () => (dispatch) => {

    const authzClient = getAuthorizedClient();
    var url;
    if(authzClient) {
        url = new URL(`${awsConfig.api.invokeUrl}${RestURI.CLIENTS}/${authzClient}`);
    }
    else{
        url = new URL(`${awsConfig.api.invokeUrl}${RestURI.CLIENTS}`);
    }
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    dispatch(clientsLoading());

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error; 
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(clients => dispatch(addClients(clients)))
        .catch(error => {
            console.log("# Error status: " + error.response.status);
            console.log("# Error: " + error);
            console.log("# Error name: " + error.name);
            console.log("# Error message: " + error.message);

            dispatch(clientsFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Clientilor" } }));
        });
}


export const fetchAllClients = () => (dispatch) => {
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.CLIENTS}`);
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    dispatch(clientsLoading());

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error; 
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(clients => dispatch(addClients(clients)))
        .catch(error => {
            console.log("# Error status: " + error.response.status);
            console.log("# Error: " + error);
            console.log("# Error name: " + error.name);
            console.log("# Error message: " + error.message);

            dispatch(clientsFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Clientilor" } }));
        });
}



export const postClient = (client) => (dispatch) => {
    client.createDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.CLIENTS, {
        method: "POST",
        body: JSON.stringify(client),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(client => dispatch(addClient(client)))
        .then(clientAction => dispatch(setBucket({ mostRecentClientId: clientAction.payload.id, snackbar: { open: true, severity: "success", message: "Clientul a fost creat cu succes" } })))
        .catch(error => {
            dispatch(clientsFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Clientului" } }));
        });
}


// ===== Not Used ======
// export const putClient = (client) => (dispatch) => {
//   client.updateDate = new Date().toISOString();
  
//   return fetch(baseUrl + RestURI.CLIENTS + `/${client.id}`, {
//       method: "PUT",
//       body: JSON.stringify(client),
//       headers: {
//         "Content-Type": "application/json"
//       },
//       credentials: "same-origin"
//   })
//   .then(response => {
//       if (response.ok) {
//         return response;
//       } else {
//         var error = new Error('Error ' + response.status + ': ' + response.statusText);
//         error.response = response;
//         throw error;
//       }
//     },
//     error => {
//       throw error;
//     }
//   )
//   .then(response => response.json())
//   .then(client => dispatch(updateClient(client)))
//   .then(clientAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Clientul salvat cu succes" } })))
//   .catch(error => { 
//     dispatch(clientsFailed(error.message));
//     dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul salvarii Clientului" } }));
//   });
// }


export const patchClient = (client) => (dispatch) => {
    client.updateDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.CLIENTS + `/${client.id}`, {
        method: "PATCH",
        body: JSON.stringify(client),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(client => dispatch(updateClient(client)))
        .then(clientAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Clientului actualizate cu succes" } })))
        .catch(error => {
            dispatch(clientsFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii Clientului" } }));
        });
}
  

export const deleteClient = (clientId) => (dispatch) => {

    const bearer = 'Bearer ' + AuthC.getJwtToken();

  return fetch(awsConfig.api.invokeUrl + RestURI.CLIENTS + `/${clientId}`, {
    method: "DELETE",
      body: JSON.stringify({}),
      headers: {
        "Content-Type": "application/json",
        'Authorization': bearer
      },
      credentials: "same-origin"
  })
  .then(response => {
      if (response.ok) {
        return response;
      } else {
        var error = new Error('Error ' + response.status + ': ' + response.statusText);
        error.response = response;
        throw error;
      }
    },
    error => {
      throw error;
    }
  )
  .then(response => response.json())
  .then(() => dispatch(removeClient(clientId)))
  .then(usrAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Utilizatorului sterse cu succes" } })))
  .catch(error => { 
    dispatch(clientsFailed(error.message));
    dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul stergerii Clientului" } }));
  });
}

